/**
 * Created by andromeda on 4/19/2017.
 */


export default class tdInitialState {

    /**
     *  gets a fresh initial state
     */
    static getNewInitialState () {
        return {
            user: null, // {}
            company: null, // {}


            /**
             * all the available permissions of the current logged in user
             */
            permissions: null, // {}

            // predefined dynamic settings
            uiDynamicSettings: {
                overtime_is_enabled: false,
                time_off_is_enabled: false,
                compensatory_time_is_enabled: false
            },


            // available premium features @see util::get_available_features
            availableFeatures: {},

            /**
             * all locked months
             */
            lockedMonths: null, // {}

            /**
             * the event list for eventList.vue
             */
            eventList: [], // all the loaded events from the server


            /**
             * all the teams that the current logged in user can see
             *  - if admin - we will load all the teams
             *  - if team_member - load only his team
             *  - if the user has permissions over other teams, that teams will appear here
             */
            teams:[], // all the teams

            locations:[], // all locations

            job_titles:[], // all locations

            projects:[], // all projects

            branchProjects: [], // a project, its children and all templates


            /**
             * all the users that the current logged in user can see
             *  - if admin - we will load all the users
             *  - team_member - all the users from his team
             *  - if the user has permissions over other teams, we will load that teams too
             */
            users:[],  // all the users

            eventsUsers: [], //users used on event add/edit

            teamsUsers: [], //teams and users

            contractTypes: [], //contract types

            employmentEndMotivations: [], //all employment end motivations

            contractSuspensionReasons: [], //contract suspension reasons

            eventTypes: [], // all the event_types available


            changesLog: [], // all log changes

			leaveDaysTypes: [], //all paid leave days types

            companyLanguage: 'en_US', // we keep the company language here because we need it even when a user is not logged in sometimes

            modalIsOpen: false, // modal state open/closed, used to add a class on main container to fix scroll on mobiles

            searchBarIsOpen: false, //search bar state open/closed

            loginRfidOn: false, //login RFID state open/closed

            isIphoneOrIpod: false, //if an user is logged in into an iphone or ipod

            isMobile: false, //if an user is logged in into an mobile SMARTphone

            subscriptionStatus: '', //subscription status

            redirectAfterLoginToUrl: null, //after a user logs in, the app will redirect to this url

            selectedRFIDDevice: null,

            unreadNotifications: 0,

            unreadReminders: 0,

            unreadComments: 0,

            accountIsConnected: null,

            accessFlagToSpvCompaniesEfactura: true

        }
    }
}



// WEBPACK FOOTER //
// ./src/tdInitialState.js